import { CompetenciaField } from '@components/Fields/CompetenciaField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { IFaturaFilter } from '@services/Relatorios/RelatorioFaturaService';
import React from 'react';

export type FaturaFilterProps = {
    filter: IFilter<IFaturaFilter>
    isLoading: boolean
}

export function FaturaFilter ({ filter, isLoading }: FaturaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <CompetenciaField
                        field={filter.fields.competencia}
                        label="Competência Vencimento"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        required
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>
           </HorizontalGrid>
        </FixedFilterPanel>
    )
}